import * as React from 'react';
import { connect } from 'react-redux';
import start from '../images/map/start.svg';
import destination from '../images/map/destination.svg';
import parking from '../images/map/parking.svg';
import pr from '../images/map/pr.svg';
import intermediate from '../images/map/intermediateStop.svg';
import change from '../images/map/changeStop.svg';
import {
  openParkingLotPopup,
} from '../actions/interactionActions';

const colors = require('../data/colors.json');
//  unsafe key here lmao
const key = "e-Tuzu0QOkZ12AgFa_8XXmUYCbl5sxM0b20S1gx8918";
const H = window.H;
const platform = new H.service.Platform({
  apikey: key
});
const munichCoordinates = { lat: 48.1371436, lng: 11.5753989 };
const startIcon = new H.map.Icon(start, { anchor: { x: 22.5, y: 22.5 }, size: { w: 42, h: 42 } });
const destinationIcon = new H.map.Icon(destination, { anchor: { x: 26, y: 30 }, size: { w: 42, h: 42 } });
const parkingIcon = new H.map.Icon(parking, { anchor: { x: 21, y: 21 }, size: { w: 42, h: 42 } });
const prIcon = new H.map.Icon(pr, { anchor: { x: 21, y: 21 }, size: { w: 42, h: 42 } });
const intermediateStop = new H.map.Icon(intermediate, { anchor: { x: 9, y: 9 } });
const changeStop = new H.map.Icon(change, { anchor: { x: 9, y: 9 } });

//  these markers are permanently integrated in the map; their state (i.e. position) are updated through user interaction
const startMarker = new H.map.Marker(munichCoordinates, { icon: startIcon });
const destinationMarker = new H.map.Marker(munichCoordinates, { icon: destinationIcon });
const parkingLotMarker = new H.map.Marker(munichCoordinates, { icon: parkingIcon });
const prMarker = new H.map.Marker(munichCoordinates, { icon: prIcon });
const routeGroup = new H.map.Group();
const transitStops = new H.map.Group();
const entryExitStops = new H.map.Group({ zIndex: 1 });

/**
 * Componenent responsible for displaying map tiles, markers, lines and map interactions
 * Props:
 *    map - used for storing the map instance; necessary for display and interaction
 */
class Map extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      map: null,
      ui: null,
      bubble: null,
      parkingLotPopupVisible: false,
    };
  }

  mapRef = React.createRef();

  //  lifecycle method necessary for instantiating the map instance
  componentDidMount = () => {

    const defaultLayers = platform.createDefaultLayers({
      lg: 'de'
    });
    const map = new H.Map(
      this.mapRef.current,
      defaultLayers.raster.normal.map,
      {
        center: munichCoordinates,
        zoom: 13,
        pixelRatio: window.devicePixelRatio || 1,
      }
    );

    // set the theme for map
    var tiles = platform.getMapTileService({ 'type': 'base' });
    var layer = tiles.createTileLayer(
      'maptile',
      'normal.day.grey',
      256,
      'png'
    );
    map.setBaseLayer(layer);

    //  needed for map interactions
    new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
    let ui = H.ui.UI.createDefault(map, defaultLayers);

    //  resizing map according to window
    window.addEventListener('resize', () => {
      map.getViewPort().resize();
    });

    map.addEventListener('mapviewchange', e => {
      try {
        if (e.newValue.lookAt.zoom < 13) {
          transitStops.setVisibility(false);
        } else {
          transitStops.setVisibility(true);
        }
      } catch {

      }
    });

    startMarker.setVisibility(false);
    destinationMarker.setVisibility(false);
    parkingLotMarker.setVisibility(false);
    parkingLotMarker.addEventListener('tap', () => {
      setTimeout(() => { this.props.openParkingLotPopup(); }, 100);
    });

    prMarker.setVisibility(false);
    prMarker.addEventListener('tap', () => {
      setTimeout(() => { this.props.openParkingLotPopup(); }, 100);
    });

    transitStops.addEventListener('pointerenter', e => {
      let bubble = new H.ui.InfoBubble(e.target.getGeometry(), {
        content: e.target.getData()
      });

      this.state.ui.addBubble(bubble);
    }, true);
    transitStops.addEventListener('pointerleave', () => {
      let bubbles = this.state.ui.getBubbles();

      bubbles.forEach(bubble => {
        this.state.ui.removeBubble(bubble);
      });
    }, true);
    entryExitStops.addEventListener('pointerenter', e => {
      let bubble = new H.ui.InfoBubble(e.target.getGeometry(), {
        content: e.target.getData()
      });

      this.state.ui.addBubble(bubble);
    }, true);
    entryExitStops.addEventListener('pointerleave', () => {
      let bubbles = this.state.ui.getBubbles();

      bubbles.forEach(bubble => {
        this.state.ui.removeBubble(bubble);
      });
    }, true);

    map.addObject(startMarker);
    map.addObject(destinationMarker);
    map.addObject(parkingLotMarker);
    map.addObject(prMarker);
    map.addObject(routeGroup);
    map.addObject(transitStops);
    map.addObject(entryExitStops);
    this.setState({ map, ui });
  }

  componentWillUnmount = () => {
    this.state.map.dispose();
  }

  //  catch as a fallback (dirty)
  updateStartMarker = () => {
    try {
      startMarker.setGeometry(this.props.startCoordinates);
      startMarker.setVisibility(true);
      parkingLotMarker.setVisibility(false);
      prMarker.setVisibility(false);
    } catch (err) {
      startMarker.setGeometry(munichCoordinates);
    }
  }

  //  catch as a fallback (dirty)
  updateDestinationMarker = () => {
    try {
      destinationMarker.setGeometry(this.props.destinationCoordinates);
      destinationMarker.setVisibility(true);
      parkingLotMarker.setVisibility(false);
      prMarker.setVisibility(false);
    } catch (err) {
      destinationMarker.setGeometry(munichCoordinates);
    }
  }

  //  marker for parking lot; TODO: get the parking lot location and set geometry of the correlating marker
  updateParkingLotRMarker = () => {
    try {
      const name = this.props.parkingLotNames[this.props.selectedRoute].toString();

      if(name.includes('P+R')) {
        prMarker.setGeometry(this.props.parkingLotLocations[this.props.selectedRoute]);
        prMarker.setVisibility(true);
      } else {
        parkingLotMarker.setGeometry(this.props.parkingLotLocations[this.props.selectedRoute]);
        parkingLotMarker.setVisibility(true);
      }

    } catch (err) {

    }
  }

  //  catch as a fallback (dirty)
  updateRoute = () => {
    try {
      //  remove previously drawn routes
      routeGroup.removeAll();
      transitStops.removeAll();
      entryExitStops.removeAll();

      //  add selected route to the map
      this.addRoute(this.props.route[this.props.selectedRoute]);
      //routeGroup.addObjects(this.props.route);
    } catch (err) {

    }
  }

  //  change the map view based user interaction
  setCenter = () => {
    switch (this.props.center) {
      //  start location has been set
      case 'start':
        this.state.map.setCenter(this.props.startCoordinates);
        break;

      //  destination location has been set
      case 'destination':
        this.state.map.setCenter(this.props.destinationCoordinates);
        break;

      //  route has been set; zooms in as close as possible
      case 'route':
        let route = new H.map.Group();
        route.addObjects([startMarker, destinationMarker]);
        this.state.map.getViewModel().setLookAtData({
          bounds: route.getBoundingBox()
        });
        this.state.map.addObject(route);
        break;
      case 'parkingLot':
        this.state.map.setCenter(this.props.parkingLotLocations[this.props.selectedRoute]);
        break;
      default:
        return;
    }
  }

  //  draw route on the map
  addRoute = route => {
    try {
      route.sections.forEach((section) => {
        let pedestrian = false;
        const type = section.type;
        var color = colors.default;

        if (type === 'transit') {
          const category = section.transport.category;

          if (category === 'S-Bahn' || category === 'U-Bahn' || category === 'Stadtbahn') {
            try {
              var name = section.transport.name;
              color = colors[name];
            } catch {
              color = colors.transit;
            }
          } else {
            color = colors[category];

            if (color === undefined) {
              color = colors.default;
            }
          }
        } else if (type === 'pedestrian') {
          pedestrian = true;
          color = colors.pedestrian;
        } else try {
          color = colors[type];
        } catch {
          color = colors.default;
        }

        if (type === 'transit') {
          entryExitStops.addObject(new H.map.Marker(
            section.departure.place.location,
            { icon: changeStop, data: section.departure.place.name }
          ));

          entryExitStops.addObject(new H.map.Marker(
            section.arrival.place.location,
            { icon: changeStop, data: section.arrival.place.name }
          ));

          section.intermediateStops.forEach(stop => {
            transitStops.addObject(new H.map.Marker(
              stop.departure.place.location,
              { icon: intermediateStop, data: stop.departure.place.name }
            ));
          });
        }

        let linestring = H.geo.LineString.fromFlexiblePolyline(section.polyline);
        let routeLine, routeBorder;

        if (pedestrian) {
          routeLine = new H.map.Polyline(linestring, {
            style: {
              strokeColor: color[1],
              lineWidth: 15,
              lineTailCap: 'round',
              lineHeadCap: 'round',
              lineDash: [0, 2],
            },
            zIndex: 3,
          });

          routeBorder = new H.map.Polyline(linestring, {
            style: {
              strokeColor: color[0],
              lineWidth: 10,
              lineTailCap: 'round',
              lineHeadCap: 'round',
              lineDash: [0, 3],
            },
            zIndex: 3,
          });
        } else {
          routeLine = new H.map.Polyline(linestring, {
            style: { strokeColor: color[1], lineWidth: 12 },
            zIndex: 1,
          });

          routeBorder = new H.map.Polyline(linestring, {
            style: { strokeColor: color[0], lineWidth: 7 },
            zIndex: 2,
          });
        }

        routeGroup.addObjects([routeLine, routeBorder]);
      });
    }
    catch (err) {
    }
  }

  render() {
    //  map updater functions
    this.updateStartMarker();
    this.updateDestinationMarker();
    this.updateParkingLotRMarker();
    this.updateRoute();
    this.setCenter();

    return (
      <div id="here-map" ref={this.mapRef} style={{ height: "94vh" }} />
    );
  }
}

const mapStateToProps = state => ({
  startCoordinates: state.posts.startCoordinates,
  destinationCoordinates: state.posts.destinationCoordinates,
  route: state.posts.route,
  center: state.posts.center,
  selectedRoute: state.posts.selectedRoute,
  parkingLotLocations: state.posts.parkingLotLocations,
  parkingLotNames: state.posts.parkingLotNames,
});

export default connect(mapStateToProps, { openParkingLotPopup })(Map)